import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { MUTUAL_FUNDS_TASK_BASE_PATH } from '../../../../../../../../../features/mutual-funds/task/mutual-funds-task-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'mutual-funds-task-list',
        label: 'Mutual Funds',
        to: MUTUAL_FUNDS_TASK_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
